<template>
  <v-container
    fluid>
    <v-row>
      <v-col
        class="pa-4 hide-on-print"
        cols="3">
        <v-row
          class="white elevation-3 rounded products-row"
          style="min-height: calc(100vh - 80px);">
          <v-col cols="12">
            <side-bar
              :prototypes="prototypes"
              :fetching-prototype="gettingPrototype"
              @add-prototype="addPrototypeToSelected($event)"
              @search="getPrototypes($event)" />
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="9"
        class="pa-4 hide-on-print"
      >
        <v-row
          style="min-height: calc(100vh - 80px);">
          <v-col
            cols="12">
            <div class="d-flex flex-row elevation-1 align-right white rounded pa-4">
              <div>
                <p class="text-h4">
                  หยิบ Care Label
                </p>
                <p class="text-body mb-0">
                  ( สินค้าที่มีหลายสีใช้ care label เดียวกันทั้งหมด )
                </p>
              </div>
              <v-spacer></v-spacer>
              <v-btn
                class="mr-2"
                color="secondary"
                text
                @click="downloadCsvTemplate()">
                <v-icon
                  class="mr-2"
                  right
                  dark
                  color="green"
                >
                  mdi-file-download-outline
                </v-icon>
                TEMPLATE
              </v-btn>
              <v-btn
                outlined
                class="mr-2"
                color="secondary"
                :loading="importing"
                :disabled="importing"
                @click="dialogImport = true">
                IMPORT FILE
              </v-btn>
              <v-btn
                color="secondary"
                :disabled="!selectedPrototype.length"
                @click="printData()">
                PRINT
              </v-btn>
              <v-dialog
                v-model="dialogImport"
                max-width="500px"
                @click:outside="onCloseCsvDialog">
                <v-card>
                  <v-card-title>Upload a File</v-card-title>

                  <v-card-text class="pb-0">
                    <p>คำเตือนเมื่อทำการเลือกไฟล์และคอนเฟิร์มรายการที่เลือกไว้ก่อนหน้าจะหายไป</p>
                    <v-file-input
                      v-model="selectedFile"
                      label="Select CSV file"
                      accept=".csv"
                      color="secondary"
                      class="my-2"
                      outlined
                      dense
                      hide-details
                      @focus="clearValidate"
                      @change="validateCsv" />
                    <p
                      v-if="csvValidateErrors.length"
                      class="text-bold">
                      Total {{ csvValidateErrors.length }} errors.
                    </p>
                    <div
                      v-if="csvValidateErrors.length"
                      class="csv-fail">
                      <p
                        v-for="(errText, index) in csvValidateErrors"
                        :key="index"
                        class="red--text">
                        {{ errText }}
                      </p>
                    </div>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      @click="onCloseCsvDialog">
                      Close
                    </v-btn>
                    <v-btn
                      color="secondary"
                      :disabled="csvValidateErrors.length > 0"
                      @click="addProductFromCsv"
                    >
                      Confirm
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
            <v-card
              v-if="prototypeNotFounds.length"
              class="white rounded mt-8 pa-4">
              <p
                class="text-bold red--text">
                รหัสสินค้าที่ไม่มีในระบบ {{ prototypeNotFounds.length }}
              </p>
              <v-card
                class="pa-2"
                max-height="100"
                style="overflow: scroll;"
                outlined
                shaped
                tile>
                <p
                  v-for="(prototypeNotFound, index) in prototypeNotFounds"
                  :key="index"
                  class="mb-2">
                  <span class="text-bold">{{ index+1 }}</span> : {{ prototypeNotFound.sketchid }}
                  <span class="text-bold">จำนวน</span> : {{ prototypeNotFound.qty }}
                </p>
              </v-card>
            </v-card>
            <v-card
              v-if="prototypeNotRequires.length"
              class="my-8 pa-4">
              <p class="font-bold text-h5 mb-0">
                สินค้าที่ไม่ต้องปรินท์ Care label
              </p>
              <div
                class="d-flex flex-column">
                <div
                  v-for="(p, i) in prototypeNotRequires"
                  :key="`no-print-${i}`">
                  <v-divider class="my-4"></v-divider>
                  <ItemBox
                    :hide-input="true"
                    v-bind="p"
                    @remove-item="removePrototypeNotRequire(i)" />
                </div>
              </div>
            </v-card>
            <v-card
              v-for="(careLabelGroup, index) in groupByCareLabels"
              :key="index"
              class="my-8">
              <v-card
                class="mx-auto"
                outlined
              >
                <v-list-item three-line>
                  <v-list-item-content>
                    <div class="text-overline d-flex mb-4">
                      <p
                        v-if="careLabelGroup.prototype[0].careLabel"
                        class="font-bold text-h5 mb-0">
                        <b>รหัส : </b>
                        {{ careLabelGroup.prototype[0].careLabel.name }}
                      </p>
                      <p
                        v-else
                        class="font-bold text-h5 mb-0 red--text">
                        สินค้าที่ยังไม่ระบุ Care Label
                      </p>
                      <v-spacer></v-spacer>
                      <v-btn
                        v-if="!careLabelGroup.prototype[0].careLabel"
                        outlined
                        color="success"
                        @click="exportCsv(careLabelGroup.prototype)">
                        EXPORT
                      </v-btn>
                    </div>
                    <v-list-item-title
                      v-if="careLabelGroup.prototype[0].careLabel"
                      class="text-h5 mb-1">
                      <b>จำนวน</b> {{ careLabelGroup.total }}
                    </v-list-item-title>
                    <v-list-item-title
                      v-else
                      class="text-h5 mb-1">
                      <b>จำนวน</b> {{ careLabelGroup.prototype.length }}
                    </v-list-item-title>
                  </v-list-item-content>
                  <img-popup-preview
                    v-model="previewEnabled"
                    :img-src="currentImgPreview" />
                  <img
                    v-if="careLabelGroup.prototype[0].careLabel"
                    width="140"
                    :src="$convertImgix(`${careLabelGroup.prototype[0].careLabel.imageUrl}?w=1024`)"
                    alt=""
                    @click="previewImg(careLabelGroup.prototype[0].careLabel.imageUrl)">
                </v-list-item>
              </v-card>
              <v-divider></v-divider>
              <div
                class="d-flex flex-column pa-4">
                <div
                  v-for="(p, i) in careLabelGroup.prototype"
                  :key="`selected-${i}`">
                  <v-divider
                    v-if="i !== 0"
                    class="my-4"></v-divider>
                  <ItemBox
                    :hide-input="!p.careLabel"
                    v-bind="p"
                    :qty="p.qty"
                    @update:qty="v => selectedPrototype[p.prototypeIndex].qty = v"
                    @remove-item="removeItem(p.prototypeIndex)" />
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <print-table
        class="print-picking-label"
        :group-by-care-labels="groupByCareLabels"></print-table>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PrototypeProvider from '@/resources/PrototypeProvider'
import SideBar from '../components/SideBar.vue'
import ItemBox from '../components/ItemBox.vue'
import PrintTable from '../components/PrintTable.vue'
import ImgPopupPreview from '@/components/ImgModalPreview.vue'
import { ExportToCsv } from 'export-to-csv'
import CareLabelProvider from '@/resources/CareLabelProvider'

const PrototypeService = new PrototypeProvider()
const fileReader = new FileReader()
const CareLabelService = new CareLabelProvider()

export default {
  components: {
    SideBar,
    ItemBox,
    ImgPopupPreview,
    PrintTable
  },
  data () {
    return {
      importing: false,
      gettingPrototype: false,
      selectedPrototype: [],
      prototypes: [],
      selectedFile: null,
      previewEnabled: false,
      currentImgPreview: '',
      dialogImport: false,
      csvValidateErrors: [],
      prototypeNotFounds: [],
      prototypeNotRequires: [],
      masterHeaderCsv: [
        'sketchid',
        'qty'
      ]
    }
  },
  computed: {
    ...mapGetters({
      store: 'Store/store'
    }),
    groupByCareLabels () {
      const grouped = this.selectedPrototype.reduce((acc, prototype, curIndex) => {
        const id = prototype.careLabel?.id
        const key = id != null ? id : 'empty'
        if (!acc[key]) {
          acc[key] = {
            prototype: [],
            total: 0
          }
        }
        const pr = { ...prototype, prototypeIndex: curIndex }
        acc[key]['prototype'].push(pr)
        acc[key]['total'] += prototype.qty
        return acc
      }, {})

      if ('empty' in grouped) {
        const { empty, ...rest } = grouped
        return { empty, ...rest }
      }

      return grouped
    }
  },
  async mounted () {
    await this.getPrototypes()
  },
  methods: {
    ...mapActions({
      setErrorPage: 'Components/setErrorPage',
      setSnackbar: 'Components/setSnackbar'
    }),
    mappingPrototype (prototype) {
      let imageUrl = ''
      const colors = prototype.products.map((pd) => pd.colors[0]).join(', ')
      if (prototype.products.length && prototype.products[0]?.photoUrls?.length) {
        imageUrl = prototype.products[0]?.photoUrls[0]
      } else if (prototype?.order?.fitting && prototype?.order?.fitting?.[0]?.images?.[0]) {
        imageUrl = prototype?.order?.fitting?.[0]?.images?.[0]
      } else if (prototype?.sketch?.images && prototype?.sketch?.images?.length) {
        imageUrl = prototype.sketch.images[0]
      }
      let careLabel = null
      if (prototype?.order?.careLabel && prototype?.order?.careLabel) {
        careLabel = prototype?.order?.careLabel
      }
      return {
        sketchId: prototype?.sketch.sketchId,
        colors,
        imageUrl,
        careLabel,
        requirePrintCareLabel: prototype.requirePrintCareLabel
      }
    },
    async getPrototypes (search = '') {
      if (this.gettingPrototype) {
        return
      }

      try {
        this.gettingPrototype = true
        const { data } = await PrototypeService.getManyPrototypeHasProduct({ search })
        this.prototypes = data.map((prototype) => this.mappingPrototype(prototype))
      } catch (error) {
        console.error('getting prototype', error)
        this.setErrorPage(error.code)
      } finally {
        this.gettingPrototype = false
      }
    },
    addAmount (index) {
      this.selectedPrototype[index].qty++
    },
    removeAmount (index) {
      if (this.selectedPrototype[index].qty > 1) {
        this.selectedPrototype[index].qty--
      }
    },
    isNumberString (str) {
      return /^\d+$/.test(str)
    },
    isMonthYearString (str) {
      const regex = /^(0[1-9]|1[0-2])-\d{4}$/
      return regex.test(str)
    },
    onCloseCsvDialog () {
      this.dialogImport = false
      this.clearValidate()
    },
    clearValidate () {
      this.selectedFile = null
      this.csvValidateErrors = []
    },
    areArraysEqual (arr1, arr2) {
      if (arr1.length !== arr2.length) return false
      const sorted1 = [...arr1].sort()
      const sorted2 = [...arr2].sort()
      return sorted1.every((val, index) => val === sorted2[index])
    },
    findDuplicates (arr) {
      return arr.filter((item, index) => arr.indexOf(item) !== index)
    },
    async addPrototypeToSelected (_prototype, qty = 1) {
      const duplicateIndex = this.prototypeNotRequires.findIndex((p) => p.sketchId === _prototype.sketchId)
      if (_prototype.requirePrintCareLabel === false) {
        if (duplicateIndex === -1) {
          this.prototypeNotRequires.push(_prototype)
        }
        return
      }
      try {
      const duplicated = this.selectedPrototype.findIndex((selected) => selected.sketchId === _prototype.sketchId)
      if (duplicated === -1) {
        let referenceCareLabel = null
        if (_prototype.careLabel) {
          const { data } = await CareLabelService.getById(_prototype.careLabel)
          referenceCareLabel = data
        }
        this.selectedPrototype.push({ ..._prototype, careLabel: referenceCareLabel, qty: Number(qty) })
      } else {
        this.selectedPrototype[duplicated].qty++
      }
    } catch (e) {
      console.error(e)
    }
    },
    removeItem (index) {
      this.selectedPrototype.splice(index, 1)
      if (!this.selectedPrototype.length) this.clearValidate()
    },
    printData () {
      const originalTitle = document.title
      document.title = 'care_label'
      window.print()
      document.title = originalTitle
    },
    previewImg (img) {
      this.currentImgPreview = img
      this.previewEnabled = !!this.currentImgPreview
    },
    validateCsv () {
      this.csvValidateErrors = []
      if (!this.selectedFile) return
      fileReader.readAsText(this.selectedFile, 'utf8')
      fileReader.onload = async (readerEvent) => {
        try {
          const contents = readerEvent.target.result.split('\n')
          const elements = []
          contents.forEach((line) => {
            if (line.trim().length > 0) {
              const text = line
                .replaceAll('"', '')
                .replaceAll('\r', '')
                .split(',')
              if (!text.every((col) => col.trim() === '')) {
                elements.push(text)
              }
            }
          })
          if (!elements || !Array.isArray(elements) || !elements.length || elements.length === 1) {
            this.csvValidateErrors.push('The CSV contains no content. Please ensure the file has valid data.')
            return
          }

          const headerFields = elements[0].filter((h) => h)

          // คอลัมน์ไม่เกินแต่ field ไม่ถูก
          if (!this.areArraysEqual(this.masterHeaderCsv, headerFields)) {
            // เกินหาว่าอะไรเกิน
            const extraHeaders = headerFields.filter((h) => !this.masterHeaderCsv.includes(h))
            if (extraHeaders.length) {
              this.csvValidateErrors.push(
                `Header : The CSV contains more header fields than required: ${extraHeaders.join(', ')}. Please remove the extra fields`
              )
            }

            // ขาดหาว่าอะไรขาด
            const missingHeaders = this.masterHeaderCsv.filter((h) => !headerFields.includes(h))
            if (missingHeaders.length) {
              this.csvValidateErrors.push(`Header : Required headers are missing: ${missingHeaders.join(', ')}. Please add them.`)
            }

            // หาว่าอะไรซ้ำ
            const duplicateField = this.findDuplicates(headerFields)
            if (duplicateField.length) {
              this.csvValidateErrors.push(`Header : ${duplicateField.join(', ')} fields are duplicated`)
            }
            return
          }

          const addRowText = (existingText, newText) => `${existingText ? ', ' : ''} ${newText}`
          for (const [index, element] of elements.entries()) {
            if (index !== 0) {
              const productInfo = Object.fromEntries(headerFields.map((key, mapIndex) => [key, element[mapIndex]]))
              let rowFailMsg = ''
              if (!productInfo['qty'] || !this.isNumberString(productInfo['qty']) || (Number(productInfo['qty']) <= 0)) {
                rowFailMsg += addRowText(rowFailMsg, 'qty')
              }
              if (!productInfo['sketchid']) rowFailMsg += addRowText(rowFailMsg, 'sketchid')
              if (rowFailMsg) {
                rowFailMsg = `Row ${index + 1} : ${rowFailMsg} must be a valid \n`
                this.csvValidateErrors.push(rowFailMsg)
              }
            }
          }
        } catch (e) {
          this.csvValidateErrors.push('Something wrong on CSV validate')
        }
      }
    },
    async addProductFromCsv () {
      this.importing = true
      if (!this.selectedFile) {
        this.setSnackbar({
          value: true,
          message: 'กรุณาเลือกไฟล์',
          type: 'error',
          timeout: 6000
        })
        this.importing = false
        return
      }
      try {
        this.selectedPrototype = []
        this.prototypeNotFounds = []
        const prototypeFromCsv = []
        const dataFromCsv = []
        await new Promise((resolve, reject) => {
          fileReader.readAsText(this.selectedFile, 'utf8')
          fileReader.onload = async (readerEvent) => {
            const contents = readerEvent.target.result.split('\n')
            contents.forEach((line) => {
              if (line.trim().length > 0) {
                const text = line
                  .replaceAll('"', '')
                  .replaceAll('\r', '')
                  .split(',')
                if (!text.every((col) => col.trim() === '')) {
                  dataFromCsv.push(text)
                }
              }
            })
            const csvHeaderAsArray = dataFromCsv[0]
            for (const [index, prototypeAsArray] of dataFromCsv.entries()) {
              if (index !== 0) {
                const skuInfo = Object.fromEntries(csvHeaderAsArray.map((key, mapIndex) => [key, prototypeAsArray[mapIndex]]))
                prototypeFromCsv.push(skuInfo)
              }
            }
            const checkDuplicateAndSum = Object.values(
              prototypeFromCsv.reduce((acc, { sketchid, qty }) => {
                const cleanSketchId = sketchid.split('.')[0]
                if (!acc[cleanSketchId]) {
                  acc[cleanSketchId] = { cleanSketchId, qty: 0, sketchIds: [] }
                }
                acc[cleanSketchId].qty += Number(qty)
                if (!acc[cleanSketchId].sketchIds.some((item) => item.sketchid === sketchid)) {
                  acc[cleanSketchId].sketchIds.push({ sketchid, qty })
                }
                return acc
              }, {})
            ).map((item) => ({ ...item, qty: item.qty }))
            await Promise.all(
              checkDuplicateAndSum.map(async (pt) => {
                const { data: prototypeLists } = await PrototypeService.getManyPrototypeHasProduct({ search: pt.cleanSketchId })
                const prototypeData = prototypeLists[0] || null
                if (prototypeData) {
                  const prototype = this.mappingPrototype(prototypeData)
                  this.addPrototypeToSelected(prototype, pt.qty)
                } else {
                  pt.sketchIds.forEach((sketchData) => {
                    this.prototypeNotFounds.push(sketchData)
                  })
                }
                return 'done'
              })
            )
          }
          resolve()
          fileReader.onerror = reject
        })
      } catch (error) {
        this.setSnackbar({
          value: true,
          message: 'ไฟล์ไม่สามารถใช้งานได้กรุณาตรวจสอบ',
          type: 'error',
          timeout: 6000
        })
      } finally {
        this.importing = false
      }
      this.dialogImport = false
      this.selectedFile = null
    },
    downloadCsvTemplate () {
      const headers = ['sketchid', 'qty']
      const values = ['GW1111', '1']
      const csvContent = [headers, values].map((e) => e.join(',')).join('\n')

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      const url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', 'care_label_template.csv')
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    exportCsv (values) {
      const exportValue = values.map(({ sketchId, imageUrl }) => ({ sketchId, imageUrl }))
      const timeStringFormat = this.$dayjs().format('DD_MM_YYYY_HHmm')
      const options = {
        filename: `no_care_label_${timeStringFormat}`,
        showLabels: true,
        useKeysAsHeaders: true
      }
      const csvExporter = new ExportToCsv(options)
      csvExporter.generateCsv(exportValue)
      this.exporting = false
    },
    removePrototypeNotRequire (index) {
      this.prototypeNotRequires.splice(index, 1)
    }
  }
}
</script>

<style>
.print-picking-label {
  display: none !important;
}
@media print {

  .print-picking-label {
    width: 100% !important;
    flex: 0 0 100% !important;
    max-width: 100% !important;
    page-break-after: always;
    page-break-before: always;
    clear: both;
    display: block !important; /* optional */
  }

  #sidebar {
    display: none !important;
  }

  header.v-sheet.theme--light.v-toolbar.v-toolbar--dense.v-app-bar.v-app-bar--fixed {
    display: none !important;
  }

  .hide-on-print {
    display: none !important;
  }

  #app main.v-main {
    padding: 0 !important;
  }
  .v-input__icon--prepend-inner,
  .v-input__icon--append {
    display: none !important;
  }
}
</style>
